import { Control, FieldValues, Path } from 'react-hook-form'

import { SmartAccountSelectInput } from '~/components/component-library'
import { useTxDisabledSmartAccounts } from '~/hooks/useTransactions'
import { IAddress } from '~/types'

export const SenderSection = <FormType extends FieldValues>({
  control,
  onSelect,
  senderInputName,
}: {
  control: Control<FormType>
  onSelect?: (value: IAddress) => void
  senderInputName: Path<FormType>
}) => {
  const txDisabledSmartAccounts = useTxDisabledSmartAccounts()

  return (
    <SmartAccountSelectInput<FormType>
      control={control}
      inputName={senderInputName}
      label="From"
      hideBalance
      setValue={onSelect}
      filteredAddresses={txDisabledSmartAccounts.map(
        (smartAccount) => smartAccount.address,
      )}
      addressLayout="standard"
    />
  )
}
